import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpCacheInterceptor } from './http-cache.interceptor';

export const httpCacheInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpCacheInterceptor, multi: true },
];
